<template>
  <div class="banner">
    <!-- <swiper :options="swiperOptiona" ref="mySwipers" class="swiper">
      <swiper-slide class="item" v-for="(item,index) in bList" :key="index">
        <img :src="`//www.dhkbearing.com/${item.picurl}`" alt />
        <div class="text">
          <p v-html="item.description[0]"></p>
          <p v-html="item.description[1]"></p>
          <p v-html="item.description[2]"></p>
        </div>
      </swiper-slide>
    </swiper>
    <div class="btns">
      <div class="btn prev">
        <i class="el-icon-caret-right"></i>
      </div>
      <div class="btn next">
        <i class="el-icon-caret-right"></i>
      </div>
    </div> -->
    <div class="bg">
      <img src="@/assets/banner1.png" alt="">
      <img src="@/assets/banner1.png" alt="">
    </div>
    <div class="text">
      <p>传动，因DHK而放心</p>
    </div>
    <form action="javascript:;" id="form">
      <input type="search" name="search" id="search" v-model="text" placeholder="您想要查找什么？">
      <button @click="goPro">
        <img src="@/assets/search.png" alt="">
        <p>搜索</p>
      </button>
    </form>
  </div>
</template>

<script>
import "swiper/dist/css/swiper.css";
import { getProductsUrl } from "../util/lang";
import "../common/jquery-1.11.3.min";
export default {
  name: "banner",
  data() {
    return {
      text:"",
      bList: [
        {
          description: ""
        }
      ],
      swiperOptiona: {
        notNextTick: true,
        navigation: {
          prevEl: ".banner .btns .prev",
          nextEl: ".banner .btns .next"
        },
        loop: true,
        effect: "fade",
        init: false,
        autoplay: {
          disableOnInteraction: false,
          delay: 5000
        }
      }
    };
  },
  mounted() {
    setTimeout(() => {
      if (this.$i18n.locale === "en") {
        this.getList("101");
      } else {
        this.getList("1");
      }
    }, 100);
  },
  methods: {
    goPro() {
      // const link = `/proSearch.html?keywords=${this.text}`
      const link = `http://products.dhkbearing.com/search_pro/search.html?keyword=${this.text}`
      window.open(link, '_self') // this.project.link
    },
    gotoAbout() {
      window.open("/intodhk.html", "_blank");
    },
    getList(id) {
      const url = `${getProductsUrl(id)}`;
      this.$axios.get(url).then(res => {
        res.data.data.map(item => {
          item.description = item.description.split("{nextPage}");
        });
        this.bList = res.data.data;
        setTimeout(() => {
          // this.$refs.mySwipers.swiper.init();
        }, 100);
      });
    }
  }
};
</script>

// <style lang="scss" scoped>
// .banner {
//   width: 100%;
//   height: 100vh;
//   position: relative;
//   .swiper {
//     height: 100%;
//     .item {
//       position: relative;
//       overflow: hidden;
//       img {
//         width: 100%;
//         height: 100%;
//         object-fit: cover;
//         display: block;
//         z-index: 1;
//         cursor: pointer;
//         /*transform: scale(1);*/
//         transition: all 3s;
//         filter: blur(5px);
//       }
//       .text {
//         z-index: 10;
//         position: absolute;
//         left: 10%;
//         top: 30%;
//         width: 80%;
//         clip-path: polygon(0 0, 0 100%, 0 100%, 0 0);
//         opacity: 0;
//         transition: all 2s;
//         transition-delay: 1s;
//         p:nth-child(1) {
//           font-family: "it";
//           font-size: 24px;
//           color: white;
//           text-transform: uppercase;
//           line-height: 35px;
//         }
//         p:nth-child(2) {
//           font-size: 42px;
//           color: white;
//           font-family: "SOURCEHANSANSCN-HEAVY";
//           margin: 30px auto;
//         }
//         p:nth-child(3) {
//           color: white;
//           line-height: 30px;
//         }
//       }
//     }
//     .swiper-slide-active {
//       img {
//         /*transform: scale(1.05);*/
//         filter: blur(0);
//       }
//       .text {
//         clip-path: polygon(0 0, 0 100%, 100% 100%, 100% 0);
//         opacity: 1;
//       }
//     }
//   }
//   .prev {
//     position: absolute;
//     left: 10%;
//     bottom: 30%;
//     cursor: pointer;
//     transition: all 1s;
//     z-index: 1000;
//     transform: rotateY(180deg);
//     &::after {
//       content: "";
//       display: inline-block;
//       width: 1px;
//       height: 26px;
//       background: rgba(255, 255, 255, 1);
//       position: absolute;
//       right: 38px;
//       top: -5px;
//     }
//     i {
//       color: white;
//       font-size: 20px;
//       transition: all 1s;
//     }
//     &:hover {
//       i {
//         color: #ffba00;
//       }
//     }
//   }
//   .next {
//     position: absolute;
//     left: 13%;
//     bottom: 30%;
//     cursor: pointer;
//     transition: all 1s;
//     z-index: 1000;
//     i {
//       color: white;
//       font-size: 20px;
//       transition: all 1s;
//     }
//     &:hover {
//       i {
//         color: #ffba00;
//       }
//     }
//   }
//   .btn:focus {
//     outline: none;
//   }
//   @media screen and (max-width: 1440px) and (min-width: 1000px) {
//     .swiper {
//     }
//   }
//   @media screen and (max-width: 1000px) {
//     .prev {
//       bottom: 5%;
//     }
//     .next {
//       bottom: 5%;
//       left: 25%;
//     }
//     .swiper {
//       .item {
//         .text {
//           p:nth-child(1) {
//             font-size: 20px;
//           }
//           p:nth-child(2) {
//             font-size: 16px;
//           }
//           p:nth-child(3) {
//             display: none;
//           }
//         }
//       }
//       .swiper-slide-active {
//         .text {
//           p:nth-child(1),
//           p:nth-child(2) {
//             width: 100%;
//           }
//         }
//       }
//     }
//   }
// }
// </style>
<style scoped>
.banner .swiper-pagination {
  bottom: 10%;
  width: 100%;
  left: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.banner .swiper-pagination >>> .swiper-pagination-bullet {
  font-size: 16px;
  font-family: "SOURCEHANSANSCN-BOLD";
  background-color: transparent;
  margin-top: 20px;
  width: 110px;
  height: auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  line-height: 50px;
  text-align: center;
  position: relative;
  color: transparent;
  transition: all 600ms;
  opacity: 1;
}
.banner .swiper-pagination >>> .swiper-pagination-bullet:focus {
  outline: none;
}
.banner .swiper-pagination >>> .swiper-pagination-bullet::after {
  width: 70px;
  height: 1px;
  background: rgba(255, 255, 255, 1);
  content: "";
  display: inline-block;
  margin-left: 10px;
}
.banner .swiper-pagination >>> .swiper-pagination-bullet::before {
  width: 0;
  height: 1px;
  transition: all 600ms;
  background: #c9432a;
  content: "";
  display: inline-block;
  position: absolute;
  left: 29px;
  top: 25px;
}
.banner .swiper-pagination >>> .swiper-pagination-bullet-active::before {
  width: 70px;
}
.banner {
  position: relative;
}
.banner .text {
  font-size: 70px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #FFFFFF;
  position: absolute;
  top: 284px;
  left: 50%;
  transform: translateX(-50%);
}
.banner .text p {
  color: #FFFFFF;
}
.banner .bg {
  width: 100%;
}
.banner .bg img {
  width: 100%;
}
.banner .bg img:nth-child(1) {
  display: block;
}
.banner .bg img:nth-child(2) {
  display: none;
}
.banner #form {
  display: flex;
  position: absolute;
  top: 412px;
  left: 50%;
  transform: translateX(-50%);
}
.banner #form input {
  width: 825px;
  height: 57px;
  background: #FFFFFF;
  border: none;
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #999999;
  padding: 0 28px;
}
.banner #form input::placeholder {
  font-size: 18px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #999999;
}
.banner #form button {
  display: flex;
  width: 125px;
  height: 57px;
  background: #F6C02E;
  align-items: center;
  justify-content: center;
  border: none;
  cursor: pointer;
}
.banner #form button p {
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #FFFFFF;
  margin-left: 9px;
}
@media screen and (max-width: 1700px) {
  .banner {
    height: 580px;
  }
  .banner .bg {
    width: 100%;
    height: 100%;
  }
  .banner .bg img {
    height: 100%;
    width: 100%;
  }
  .banner .text {
    font-size: 60px;
  }
  .banner #form {
    top: 50%;
    transform: translate(-50%,-50%);
    display: flex;
  }
  .banner #form input ,.banner #form button {
    display: flex;
  }
  .banner .text {
    top: 35%;
    transform: translate(-50%,-50%);
  }
}
@media screen and (max-width: 1440px) {
  .banner .text {
    font-size: 50px;
  }
}
@media screen and (max-width: 1024px) {
  .banner {
    height: 60vh;
  }
  .banner .bg {
    height: 100%;
  }
  .banner .bg img {
    height: 100%;
    width: unset;
  }
  .banner .bg {
    background: url('../assets/banner1.png') no-repeat;
    background-position:right bottom;
    background-size: auto 100%;
  }
  .banner .bg img:nth-child(1) {
  display: none;
}
.banner .bg img:nth-child(2) {
  display: none;
}
  .banner .text {
    font-size: 32px;
    text-align: center;
    width: 100%;
    top: 45%;
  }
  .banner #form {
    width: 90%;
    top: 60%;
  }
  .banner #form input {
    width: 70%;
    height: 40px;
    position: relative;
    left: 1px;
    border-radius: unset !important;
  }
  .banner #form button {
    height: 40px;
    width: 30%;
  }
  .banner #form input::placeholder {
    font-size: 14px;
  }
}
</style>
